import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

export default function Recruitment() {
  const [selectedCandidate, setSelectedCandidate] = useState(null);

  const [candidates, setCandidates] = useState([
    {
      name: "Micheal calins",
      email: "Micheal@gmail.com",
      role: "Software Developer",
      date: "05 Apr 2026",
      status: "Active",
      image: "myimg.jpg"
    },
    {
      name: "Ajith kumar",
      email: "Ajith@gmail.com",
      role: "Software Developer",
      date: "05 Apr 2026",
      status: "Active",
      image: "ajith.png"
    },
    {
      name: "Vasanth",
      email: "Vasanth@gmail.com",
      role: "Software Developer",
      date: "05 Apr 2026",
      status: "Active",
      image: "https://randomuser.me/api/portraits/men/3.jpg"
    },
    {
      name: "Shesha",
      email: "Shesha@gmail.com",
      role: "Software Developer",
      date: "05 Apr 2026",
      status: "Active",
      image: "https://randomuser.me/api/portraits/men/4.jpg"
    },
    {
      name: "Arjun",
      email: "Arjun@gmail.com",
      role: "UI/UX Designer",
      date: "05 Apr 2026",
      status: "Active",
      image: "https://randomuser.me/api/portraits/men/5.jpg"
    },
    {
      name: "Kiran",
      email: "Kiran@gmail.com",
      role: "Backend Developer",
      date: "05 Apr 2026",
      status: "Active",
      image: "https://randomuser.me/api/portraits/men/6.jpg"
    },
    {
      name: "Rahul",
      email: "Rahul@gmail.com",
      role: "DevOps Engineer",
      date: "05 Apr 2026",
      status: "Active",
      image: "https://randomuser.me/api/portraits/men/7.jpg"
    },
    {
      name: "Suresh",
      email: "Suresh@gmail.com",
      role: "QA Engineer",
      date: "05 Apr 2026",
      status: "Active",
      image: "https://randomuser.me/api/portraits/men/8.jpg"
    },
    {
      name: "Manoj",
      email: "Manoj@gmail.com",
      role: "Frontend Developer",
      date: "05 Apr 2026",
      status: "Active",
      image: "https://randomuser.me/api/portraits/men/9.jpg"
    }
  ]);

  const updateStatus = (newStatus) => {
    const updated = candidates.map((c) =>
      c.email === selectedCandidate.email
        ? { ...c, status: newStatus }
        : c
    );

    setCandidates(updated);
    setSelectedCandidate({ ...selectedCandidate, status: newStatus });
  };

  return (
    <div className="container py-4">
      <div className="row g-4">
        {candidates.map((c, index) => (
          <div className="col-lg-4 col-md-6 col-sm-12" key={index}>
            <div className="card border-0 shadow-sm rounded-4 p-3 hover-card h-100">

              {/* Header */}
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center gap-3">
                  <img
                    src={c.image}
                    alt="avatar"
                    className="rounded-circle"
                    width="45"
                    height="45"
                  />

                  <div>
                    <h6 className="mb-0 fw-semibold">{c.name}</h6>
                    <small className="text-muted">{c.email}</small>
                  </div>
                </div>

                <span className="badge bg-warning-subtle text-warning">
                  Applied
                </span>
              </div>

              {/* Button */}
              <div className="text-end mt-3">
                <button
                  className="btn btn-sm btn-primary rounded-pill px-3"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#viewDrawer"
                  onClick={() => setSelectedCandidate(c)}
                >
                  View →
                </button>
              </div>

              {/* Info Section */}
              <div className="bg-light rounded-4 p-3 mt-3 small flex-grow-1">
                <div className="d-flex justify-content-between mb-2">
                  <span>Applied Role</span>
                  <span className="fw-semibold">{c.role}</span>
                </div>

                <div className="d-flex justify-content-between mb-2">
                  <span>Applied Date</span>
                  <span className="fw-semibold">{c.date}</span>
                </div>

                <div className="d-flex justify-content-between">
                  <span>Status</span>
                  <span className="badge bg-purple text-white px-2">
                    {c.status}
                  </span>
                </div>
              </div>

            </div>
          </div>
        ))}
      </div>

      {/* OFFCANVAS */}
      <div className="offcanvas offcanvas-end" id="viewDrawer">
        <div className="offcanvas-header">
          <h5>Candidate Details</h5>
          <button className="btn-close" data-bs-dismiss="offcanvas"></button>
        </div>

        <div className="offcanvas-body">
          {selectedCandidate && (
            <div className="text-center">
              <img
                src={selectedCandidate.image}
                alt={selectedCandidate.name}
                className="rounded-circle mb-3"
                width="80"
              />

              <h5>{selectedCandidate.name}</h5>
              <p className="text-muted">{selectedCandidate.email}</p>

              <hr />

              <div className="text-start">
                <p><b>Role:</b> {selectedCandidate.role}</p>
                <p><b>Date:</b> {selectedCandidate.date}</p>
                <p>
                  <b>Status:</b>{" "}
                  <span
                    className={`badge ${
                      selectedCandidate.status === "Selected"
                        ? "bg-success"
                        : selectedCandidate.status === "Rejected"
                        ? "bg-danger"
                        : "bg-purple"
                    }`}
                  >
                    {selectedCandidate.status}
                  </span>
                </p>
              </div>

              <div className="d-flex gap-2 mt-4">
                <button
                  className="btn btn-success w-100"
                  onClick={() => updateStatus("Selected")}
                >
                  Accept
                </button>

                <button
                  className="btn btn-danger w-100"
                  onClick={() => updateStatus("Rejected")}
                >
                  Reject
                </button>
              </div>

            </div>
          )}
        </div>
      </div>

      {/* Styles */}
      <style>{`
        .bg-purple {
          background-color: #7c3aed;
        }

        .hover-card:hover {
          transform: translateY(-5px);
          transition: 0.3s;
          box-shadow: 0 10px 25px rgba(0,0,0,0.1);
        }
      `}</style>
    </div>
  );
}